/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

require('../styles/CorpFinRegUnderwriterFormView.css');
var tmplCorpFinRegUnderwriterFormView = require('../templates/CorpFinRegUnderwriterFormView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinRegUnderwriterFormView,

  className: 'corp-fin-reg-underwriter-form-view',

  ui: {
    removeUnderwriter: '.remove-underwriter'
  },

  triggers: {
    'click @ui.removeUnderwriter': 'remove:underwriter'
  },

  templateHelpers: function() {
    return {
      childIndex: this.options.childIndex + 1
    };
  },

  onBeforeShow: function() {
    Syphon.deserialize(this, this.model.toJSON());
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    return formData;
  }
});
